import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

import Moment from 'moment'

const Item = (props) => {
  let status = 'No Sample Provided'
  if (props.row.portfolios && props.row.portfolios.count > 0) {
    let reviewCounter = 0
    let approveCounter = 0
    props.row.portfolios.rows.map((sample) => {
      if (props.row.status === props.statusList.rejected.value) {
        status = 'Rejected'
      }
      if (props.row.status === props.statusList.onReview.value) {
        status = 'Need Review'
        if (sample.portfolio.status === props.statusList.approved.value) {
          approveCounter += 1
        }
        if (sample.portfolio.status === props.statusList.onReview.value) {
          reviewCounter += 1
        }
        if (sample.portfolio.status === props.statusList.rejected.value && (
          approveCounter === 0 && reviewCounter === 0
        )) {
          status = 'No Sample Provided'
        }
      }
      if (props.row.status === props.statusList.approved.value) {
        status = 'No Sample Provided'
        if (sample.portfolio.status === props.statusList.rejected.value && (
          approveCounter === 0 && reviewCounter === 0
        )) {
          status = 'No Sample Provided'
        } else if (sample.portfolio.status === props.statusList.approved.value) {
          approveCounter += 1
          status = 'Approved'
        } else {
          reviewCounter += 1
          status = 'Need Review'
        }
      }
      return status
    })
  }
  return (
    <tr>
      <td> {parseInt(props.skip, 0) + props.indexKey + 1} </td>
      <td> {Moment(`${props.row.createdAt}`).format('MMMM, DD YYYY')} </td>
      <td> <span className="capitalize">{props.row.name} </span></td>
      <td>
        <span> <Link to={`/profiles/${props.row.profile.profileId}`}>
          {props.row.profile.profileId}
        </Link> </span>
      </td>
      <td> <span> {props.row.profile.name} </span></td>
      <td> <span> {props.row.country.name} </span></td>
      <td> <span> {props.row.productType.name} </span></td>
      <td> <span> {props.row.service.name} </span></td>
      <td> <span> {props.row.format.name} </span></td>
      <td> <span> {status} </span></td>
      <td>
        <Link to={`/products-brand-new/${props.row.id}`} className="btn btn-icon-only red">
          <i className="fa fa-eye" />
        </Link>
      </td>
    </tr>
  )
}

Item.defaultProps = {
  row: {
    id: '',
    createdAt: '',
    name: '',
    profileId: '',
    url: '',
  },
  skip: 0,
  indexKey: 0,
}

Item.propTypes = {
  statusList: PropTypes.shape({
    onReview: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }).isRequired,
    approved: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }).isRequired,
    rejected: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    portfolios: PropTypes.shape({
      count: PropTypes.number.isRequired,
      rows: PropTypes.arrayOf(PropTypes.object).isRequired,
    }),
    profile: PropTypes.shape({
      profileId: PropTypes.string.isRequired,
      name: PropTypes.string,
    }).isRequired,
    country: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    productType: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    service: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    format: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  skip: PropTypes.number.isRequired,
  indexKey: PropTypes.number.isRequired,
}

export default Item
